import { Interaction, Tooltip } from "chart.js";
import React, { useRef, useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { Line } from "react-chartjs-2";
import { Chart } from "chart.js/auto"; // Include auto for convenience

const DigitalAssetsChart = ({
  dates,
  mutualFunds,
  stocks,
  bankStatements,
  nps,
}) => {
  const [datasetsArray, setsDatasetsArray] = useState([]);
  const [datasetsArrayBackup, setsDatasetsArrayBackup] = useState([]);
  const screenWidth = window.innerWidth;
  const [graphwidth, setGraphWidth] = useState("180");

  // if(screenWidth>2500){
  // setGraphWidth("100");
  // }

  const arrayInitialize = () => {
    setsDatasetsArray([
      {
        label: "Mutual Funds",
        data: mutualFunds, //[0, 2, 3, 4, 5, 6, 7, 8, 9, 10]
        // backgroundColor: "#f7a452",
        borderColor: "#f7a452",
        backgroundColor: "#f7a452",
      },
      {
        label: "Stocks",
        data: stocks, //[0, 20, 30, 40, 50, 60, 70, 80, 90, 100]
        // backgroundColor: "#99CEFF",
        borderColor: "#9d53f2",
        backgroundColor: "#9d53f2",
      },
      {
        label: "Bank Statement",
        data: bankStatements, //[0, 20, 30, 40, 50, 60, 70, 80, 90, 100]
        // backgroundColor: "#99CEFF",
        borderColor: "#26aba4",
        backgroundColor: "#26aba4",
      },
      {
        label: "NPS",
        data: nps, //[0, 20, 30, 40, 50, 60, 70, 80, 90, 100]
        // backgroundColor: "#99CEFF",
        borderColor: "#ff88a5",
        backgroundColor: "#ff88a5",
      },
    ]);
    setsDatasetsArrayBackup([
      {
        label: "Mutual Funds",
        data: mutualFunds, //[0, 2, 3, 4, 5, 6, 7, 8, 9, 10]
        // backgroundColor: "#f7a452",
        borderColor: "#f7a452",
        backgroundColor: "#f7a452",
      },
      {
        label: "Stocks",
        data: stocks, //[0, 20, 30, 40, 50, 60, 70, 80, 90, 100]
        // backgroundColor: "#99CEFF",
        borderColor: "#9d53f2",
        backgroundColor: "#9d53f2",
      },
      {
        label: "Bank Statement",
        data: bankStatements, //[0, 20, 30, 40, 50, 60, 70, 80, 90, 100]
        // backgroundColor: "#99CEFF",
        borderColor: "#26aba4",
        backgroundColor: "#26aba4",
      },
      {
        label: "NPS",
        data: nps, //[0, 20, 30, 40, 50, 60, 70, 80, 90, 100]
        // backgroundColor: "#99CEFF",
        borderColor: "#ff88a5",
        backgroundColor: "#ff88a5",
      },
    ]);
  };
  function formatToIndianRupees(num) {
    // Convert the number to a string
    if (num === null || num === undefined) return "₹--";
    let floatedValue = parseFloat(num);
    return floatedValue.toLocaleString("en-IN", {
      maximumFractionDigits: 2,
      style: "currency",
      currency: "INR",
    });
  }
  function indianNumberFormat(num) {
    if (num >= 1e7) {
      num = num / 1e7;
      return `${num.toFixed(2)} Cr`;
    } else if (num >= 1e5) {
      num = num / 1e5;
      return `${num.toFixed(2)} L`;
    } else if (num >= 1e3) {
      num = num / 1e3;
      return `${num.toFixed(2)} K`;
    }
    return num.toString();
  }

  useEffect(() => {
    arrayInitialize();
  }, [mutualFunds, stocks, bankStatements]);

  const options = {
    maintainAspectRatio: false,
    responsive: true,
    interaction: {
      intersect: true,
      mode: "index",
    },

    scales: {
      y: {
        ticks: {
          callback: function (value, index, values) {
            return indianNumberFormat(value); // Add a dollar sign and format to two decimal places
          },

          font: {
            size: 10, // Adjust font size to your preference (in pixels)
            family: "Inter", // Adjust font size to your preference
          },
        },
        suggestedMin: 0,
        beginAtZero: true,
        stacked: false,
        grid: {
          display: false,
        },
        title: {
          display: true,
          text: "Amount (₹)",
          font: "Inter",
          style: "none", // Label for the y-axis
        },
      },
      x: {
        ticks: {
          font: {
            size: 9,
            family: "inter", // Adjust font size to your preference (in pixels)
          },
        },
      },
    },
    plugins: {
      tooltip: {
        callbacks: {
          label: function (tooltipItem, data) {
            return `${tooltipItem.dataset.label} : ${formatToIndianRupees(
              tooltipItem.raw
            )}`;
          },
        },
        backgroundColor: "#656565",
        boxPadding: 7,
        padding: 15,
        cornerRadius: 4,
        bodyColor: "white",
        caretSize: 0,
        lineHeight: 3,
        bodyFont: {
          size: 12,
          lineHeight: 2,
          weight: "normal",
        },
      },
      layout: {
        padding: {
          bottom: 100, // Increase the top padding to create space between legend and graph
        },
      },
      legend: {
        onClick: (evt, legendItem, legend) => {
          if (datasetsArray.length < 2) {
            setsDatasetsArray(datasetsArrayBackup);
            return;
          }
          setsDatasetsArray(
            datasetsArray.filter((item) => item.label === legendItem.text)
          );
          // setsDatasetsArray(prev=>{
          //   prev.filter(item=>item.label===legendItem.text)
          // })
        },

        position: "bottom", // Change the position of the legend

        labels: {
          boxWidth: 8, // Width of the colored box
          boxHeight: 8,
          // Use data point style as legend icon
          color: "#637381", // Text color
          padding: 15,
        },
      },
    },
  };

  const data = {
    labels: dates,
    datasets: datasetsArray,
  };
  return (
    <div className="   mt-[0px] ">
      <Line data={data} options={options} height={"270px"} width={"320px"} />
    </div>
  );
};

export default DigitalAssetsChart;
